import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

//# QGIS Generated Color Map Export File
//INTERPOLATION:DISCRETE
// Palette contains in each row the maximum altitude, R,G,B color, and legend text
const palette = [
  [2, 0, 0, 88, 255, "< 2 m"],
  [4, 0, 77, 0, 255, "2-4 m"],
  [50, 0, 116, 0, 255, "4-50 m"],
  [100, 0, 155, 0, 255, "50-100 m"],
  [200, 0, 194, 0, 255, "100-200 m"],
  [300, 59, 216, 12, 255, "200-300 m"],
  [450, 137, 231, 27, 255, "300-450 m"],
  [600, 216, 247, 43, 255, "450-600 m"],
  [750, 255, 239, 51, 255, "600-750 m"],
  [950, 255, 208, 51, 255, "750-950 m"],
  [1200, 255, 177, 51, 255, "950-1200 m"],
  [1450, 243, 145, 47, 255, "1200-1450 m"],
  [1750, 196, 114, 31, 255, "1450-1750 m"],
  [2050, 149, 82, 16, 255, "1750-2050 m"],
  [2350, 102, 51, 0, 255, "2050-2350 m"],
  [5000, 102, 51, 0, 255, "2350-5000 m"], // same color as previous to indicate 2350m and above
];

export const digitalElevationModelColorList = palette.map(
  ([_val, r, g, b, _a, _txt]) => `rgb(${r}, ${g}, ${b})`,
);

export const DigitalElevationModelLegend = ({ customLegendStyle = legendStyle }) => {
  const { t } = useTranslation();

  return (
    <div style={customLegendStyle}>
      <div>
        <b>{t("legend.digitalElevationModel")}</b>
      </div>

      {palette.map(([value, r, g, b, a, label]) => (
        <div key={value}>
          <span style={legendItemStyle(`rgba(${r}, ${g}, ${b}, ${a / 255})`)}></span>
          {label}
        </div>
      ))}

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          {t("riskExposureMapExplained.digitalElevationModel")}
        </span>
      </div>
    </div>
  );
};
